// extracted by mini-css-extract-plugin
export default {"category_list":"CategoryList_category_list__uhnux","list_info":"CategoryList_list_info__yVnGV","list_in":"CategoryList_list_in__L2LkK","list_out":"CategoryList_list_out__CoZ2V"};